export default __webpack_public_path__ + "static/media/limoneTtsIt_It60.53186b08.mp3";